import { useCallback, useState } from 'react'

interface UseSubmitToSkatFormReturn {
  isSubmissionFormOpen: boolean
  submissionDeclarationId: string | null
  setIsSubmissionFormOpen: (isOpen: boolean, declarationId?: string) => void
}

export const useSubmitToSkatForm = (): UseSubmitToSkatFormReturn => {
  const [isSubmissionFormOpen, setIsSubmissionFormOpenState] = useState(false)
  const [submissionDeclarationId, setSubmissionDeclarationId] = useState<string | null>(null)

  const setIsSubmissionFormOpen = useCallback((isOpen: boolean, declarationId?: string) => {
    if (isOpen && declarationId) {
      setSubmissionDeclarationId(declarationId)
      setIsSubmissionFormOpenState(true)
    }

    if (!isOpen) {
      setIsSubmissionFormOpenState(false)
      setSubmissionDeclarationId(null)
    }
  }, [])

  return {
    isSubmissionFormOpen,
    submissionDeclarationId,
    setIsSubmissionFormOpen,
  }
}
